import axios from 'axios';

const getAppleWalletPass = (customerId, merchantId) => {
  return axios({
    url: `/mole/wallet/apple/${merchantId}/${customerId}`,
    method: 'POST',
    responseType: 'blob',
  });
};

const getGoogleWalletPass = (customerId, merchantId) => {
  return axios({
    url: `/mole/wallet/google/${merchantId}/${customerId}`,
    method: 'POST',
  });
};

export default {
  getAppleWalletPass,
  getGoogleWalletPass,
};
